import { useState } from 'react';

import { TrackMapSortBy } from 'src/helpers/filterTrackMaps';
import { PublishedFilter } from 'src/helpers/publishedFilter';
import { EOrder } from 'src/interfaces/Order';

export function useTrackMapListFilters() {
  const [query, setQuery] = useState('');
  const [distanceFilter, setDistanceFilter] = useState<string | null>(null);
  const [publishedFilter, setPublishedFilter] = useState<PublishedFilter>('all');
  const [order, setOrder] = useState<EOrder>(EOrder.asc);
  const [orderByKey, setOrderByKey] = useState<TrackMapSortBy>('name');

  return {
    query,
    distanceFilter,
    publishedFilter,
    order,
    orderByKey,
    setQuery,
    setDistanceFilter,
    setPublishedFilter,
    setOrder,
    setOrderByKey,
  };
}
